import { Box, Chip } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import isExpired from "./isExpired";
import { SmimeCert } from "@dashboard-v3/api";

export default function CertTypeChip({ cert }: { cert: SmimeCert }) {
  const { t } = useTranslation("smime");

  if (isExpired(cert)) {
    return (
      <Chip
        variant="outlined"
        color="secondary"
        size="small"
        label={
          <Box display="flex" gridGap=".2rem">
            <strong>{cert.format}</strong>
            {t("item.expired")}
          </Box>
        }
      />
    );
  }

  return (
    <Chip
      variant="outlined"
      color="primary"
      size="small"
      label={
        <Box display="flex" gridGap=".2rem">
          <strong>{cert.format}</strong>
          {t("item.active")}
        </Box>
      }
    />
  );
}
